import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, API, CATEGORY_LABELS, measureRows } from "@/lib/api";
import { OnboardingBox } from "./OnboardingBox";
import { SheetLink } from "./SheetLink";

export const ApplicationDialog = ({ id, onClose, onChange, statusLabels }) => {
  const [a, setA] = useState(null);

  useEffect(() => {
    api.get(`/admin/applications/${id}`).then((r) => setA(r.data)).catch(() => { toast.error("Candidatura non trovata"); onClose(); });
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const setStatus = async (status) => {
    await api.patch(`/admin/applications/${id}`, { status });
    setA((x) => ({ ...x, status }));
    onChange();
  };
  const remove = async () => {
    if (!window.confirm("Eliminare questa candidatura?")) return;
    await api.delete(`/admin/applications/${id}`);
    onChange(); onClose();
  };

  const rows = a ? [["Categoria", CATEGORY_LABELS[a.category]?.it], ["Agente", a.agent_name || "Nessuno (sito)"], ["Nota", a.status_note], ["Sesso", a.gender === "F" ? "Donna" : "Uomo"], ["Altezza", `${a.height} cm`], ...measureRows(a), ["Data di nascita", a.birth_date ? `${a.birth_date} (${a.age} anni)` : a.age],
    ["Genitore/tutore", a.is_minor ? `${a.parent_name} · ${a.parent_email} · ${a.parent_phone}` : ""], ["Mother agency", a.mother_agency || "Nessuna"],
    ["Email", a.email], ["Telefono", a.phone], ["Città", a.city], ["Nazionalità", a.nationality], ["Instagram", a.instagram], ["Messaggio", a.message]] : [];

  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="application-dialog" className="max-h-[90vh] max-w-3xl overflow-y-auto rounded-none bg-white" data-lenis-prevent>
        {!a ? <DialogTitle className="font-mono text-xs font-normal">Caricamento…</DialogTitle> : (
          <>
            <DialogHeader><DialogTitle className="font-display text-5xl uppercase leading-none">{a.first_name} {a.last_name}</DialogTitle></DialogHeader>
            {a.has_video && <video controls preload="metadata" src={`${API}/admin/applications/${a.id}/video`} data-testid="application-video" className="mb-3 max-h-[60vh] w-full bg-black" />}
            <div className="grid grid-cols-3 gap-2" data-testid="application-photos">
              {(a.photos || []).map((p, i) => <a key={i} href={p} download={`${a.last_name}-${i + 1}.jpg`}><img src={p} alt="" className="aspect-[3/4] w-full object-cover" /></a>)}
              {!a.photos?.length && <p className="col-span-3 font-serif italic">Nessuna foto caricata.</p>}
            </div>
            <table className="w-full"><tbody>
              {rows.map(([k, v]) => (
                <tr key={k} className="border-b border-[#1c1418]/15"><td className="py-2 font-mono text-[11px] uppercase tracking-[0.2em] text-[#1c1418]/60">{k}</td><td className="py-2 text-right">{v || "—"}</td></tr>
              ))}
            </tbody></table>
            <div className="flex flex-wrap gap-2">
              {Object.entries(statusLabels).map(([k, v]) => (
                <button key={k} onClick={() => setStatus(k)} data-testid={`application-status-${k}`}
                  className={`px-4 py-2 font-mono text-xs uppercase tracking-[0.15em] ${a.status === k ? "bg-[#1c1418] text-white" : "border border-[#1c1418]/30"}`}>{v}</button>
              ))}
              <button onClick={remove} data-testid="application-delete" className="ml-auto px-4 py-2 font-mono text-xs uppercase tracking-[0.15em] text-[#1c1418]/60">Elimina</button>
            </div>
            {a.status === "approved" && <SheetLink appId={a.id} />}
            {a.status === "approved" && <OnboardingBox appId={a.id} />}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
